import { Link } from 'expo-router'
import { useCallback, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'

import { BigRedButton, DeadCenterScreen, PasswordInput, Text, TextInput } from '@/components'
import { useAuth, useFocusableRef } from '@/hooks'

import { SocialButtons } from './SocialButtons'

export const SignInScreen = () => {
  const [buttonRef, focusButton] = useFocusableRef()
  const [passwordRef, focusPassword] = useFocusableRef<RNTextInput>()
  const { isSigningIn, signInWithCredentials } = useAuth()
  const [email, setEmail] = useState(__DEV__ ? 'user+1@twobitsolutions.xyz' : '')
  const [password, setPassword] = useState(__DEV__ ? 'xyz' : '')

  const handleSignInWithCredentials = useCallback(
    () => signInWithCredentials({ email, password }),
    [email, password, signInWithCredentials]
  )
  const isValid = email && password
  const isDisabled = !isValid || isSigningIn

  return (
    <DeadCenterScreen>
      <TextInput
        inputFieldProps={{
          autoCapitalize: 'none',
          autoComplete: 'email',
          keyboardType: 'email-address',
          onSubmitEditing: () => focusPassword(),
          returnKeyType: 'next',
          testID: 'SignInScreen.emailInput',
          textContentType: 'emailAddress'
        }}
        isDisabled={isSigningIn}
        label='Email'
        onChange={setEmail}
        value={email}
      />
      <PasswordInput
        inputFieldProps={{
          autoComplete: 'current-password',
          onSubmitEditing: () => focusButton(),
          returnKeyType: email && password ? 'next' : 'none',
          testID: 'SignInScreen.passwordInput',
          textContentType: 'password'
        }}
        isDisabled={isSigningIn}
        onChange={setPassword}
        ref={passwordRef}
        value={password}
      />
      <BigRedButton
        className='mt-6 h-16'
        isDisabled={isDisabled}
        isLoading={isSigningIn}
        onPress={handleSignInWithCredentials}
        ref={buttonRef}
        testID='SignInScreen.signInButton'
      >
        Sign in with email
      </BigRedButton>
      <SocialButtons />
      <Text
        className='text-center text-white underline'
        size='sm'
      >
        <Link
          testID='SignInScreen.signUpLink'
          accessibilityRole='link'
          accessibilityState={{
            disabled: isSigningIn
          }}
          disabled={isSigningIn}
          href='/sign-up'
        >
          No account yet? Sign Up.
        </Link>
      </Text>
      <Text
        className='text-center text-white underline'
        size='sm'
      >
        <Link
          testID='SignInScreen.forgotPasswordLink'
          accessibilityRole='link'
          accessibilityState={{
            disabled: isSigningIn
          }}
          disabled={isSigningIn}
          href={{
            pathname: '/forgot-password',
            params: { email }
          }}
        >
          Forgot Password?
        </Link>
      </Text>
    </DeadCenterScreen>
  )
}
